const book_list = [
  {
    id: '166300',
    name: '特别的归乡者',
    description: '大雨冲垮了小金河桥，老村支书前往省城找建筑商陈飞黄资助修桥，陈飞黄给了他五万块，可这笔钱根本不够修桥，老村支书不知道，其实陈飞黄早已破产。 陈飞黄出门躲债，在火车站遇到同乡猴子和二傻。二傻在建筑工地打工摔伤了腿，陈飞黄决定护送他回老家。 二傻腿伤严重，需要手术，陈飞黄指导猴子找包工头讨要赔偿金，猴子按照陈飞黄的方法，成功的要到了赔偿金，对陈飞黄崇拜不已。 老村支书为了修桥跌入河里，一病不起，猴子推荐陈飞黄当村支书，村干部得知陈飞黄破产的事，坚决反对，被老村支书说服。 从此以后，陈飞黄带领村民走上致富的道路…… 入选2020年中国作家协会重点扶持。',
    author: '夜神翼',
    cate1_id: '285',
    word_count: '281818',
    cover: 'https://readstatic.zhulang.com/res/cover/166/300/166300_180.jpg?1600364008'
  },
  {
    id: '157565',
    name: '传国功匠',
    description: '中国东南沿海瓯江流域，为了一个七十年前不同寻常的盟约，五家顶级瓯派（温州）匠工的传人在寻找秘笈《瓯宝图》过程中，与境外正邪两大力量之间发生殊死冲突及各派瓯越匠人之间颇有历史渊源的爱恨情仇的传奇。\n' +
      '【主要故事线索】：\n' +
      '1、中国瓯匠与上世纪来到中国的传教士订立了70年护宝盟约。\n' +
      '2、瓯匠传人为寻找《瓯宝图》以及“瓯宝”，与境外邪恶势力的生死夺宝。\n' +
      '3、瓯匠传人之间的几代人爱恨情仇以及与境外善恶两大力量的历史恩怨纠缠。\n' +
      '本书荣获2019优秀网络文学原创作品推介、2019扬子江原创网络文学大赛特别奖。',
    author: '陈酿',
    cate1_id: '283',
    word_count: '209056',
    cover: 'https://readstatic.zhulang.com/res/cover/157/565/157565_180.jpg?1600366955'
  },
  {
    id: '167736',
    name: '2.24米的天际',
    description: '一位海归“菜鸟”年轻姑娘，被中国排协邀请担任中国女排二队主教练，带领一群20岁出头的”二队“选手不忘初心为了梦想去奋斗。在危机之际，她们”接棒“中国女排，为了”升国旗、奏国歌“的誓言，为了传承”祖国至上、团结协作、顽强拼搏、永不言败“的女排精神，她们砥砺前行…… 入选2020年中国作家协会重点扶持。',
    author: '行知',
    cate1_id: '56',
    word_count: '658239',
    cover: 'https://readstatic.zhulang.com/res/cover/167/736/167736_180.jpg?1600363756'
  },
  {
    id: '26791',
    name: '心照日月',
    description: '这是一部反映我国基层法院法官办案生活的长篇小说。本书以朴素的语言，讲述了一群基层法官的喜怒哀乐酸甜苦辣。面对压力，他们用正气战胜妥协；面对诱惑，他们用淡定抵御冲动；面对恐吓，他们用凛然涤荡怯懦。他们用热血、智慧，甚至生命，展示了基层法官的理想、信念、责任、担当。\n' +
      '本书获得国家新闻出版广电总局、中国作家协会推荐的“2017优秀网络文学原创作品”、2018年中国网络文学二十年江苏20部代表作品入选。',
    author: '乔雅',
    cate1_id: '159',
    word_count: '214606',
    cover: 'https://readstatic.zhulang.com/res/admincover/026/791/26791_180.jpg?1582774246'
  },
  {
    id: '156202',
    name: '旷世烟火',
    description: '故事从1949年开始，以中国东南300里楠溪江流域第一大财主家新寡的徐大小姐为主人公，通过这位文弱女子大起大落的生活为背景，描写与她相关的各个历史背景下各个阶层的家族和社会人物， 展现一幅从新中国成立到“改革开放40年”共70年期间，中国东南大地——瓯江两岸的社会形象的历史画卷，由徐大小姐的生活线为脉络，史诗般展现温州这块神奇土地上各个社会阶层各种人物在各个特殊历史阶段的政治、经济、人文、风土和情感历程。《旷世烟火》将是一部偏重于感性和个人主义的家族史、风俗史以及个人命运的沉浮史，也将是一部浓缩性的东南大地新中国成立后的百姓命运史和心灵史。\n' +
      '【向新中国成立70周年献礼参赛作品】该作品获得2019年中国作家协会重点作品扶持、2019全国首届现实题材主题征文大赛未完结组一等奖、第三届中国“网络文学+”大会中被评为“年度十大影响力IP入围作品”。',
    author: '陈酿',
    cate1_id: '285',
    word_count: '509146',
    cover: 'https://readstatic.zhulang.com/res/admincover/156/202/156202_180.jpg?1582785903'
  },
  {
    id: '171900',
    name: '冬雪暖阳',
    description: '这是一部关于青少年法治题材的小说。 边亮是一个青春叛逆期的少年，他稀里糊涂犯罪，懵懵懂懂入狱。 从小就被父母抛弃，后两次被收养，特殊的成长经历使他的性格孤僻、冷漠，缺乏一颗感恩的心。 养母方林妹是一个普通的农村妇女，善良、软弱，对于如何教育叛逆的边亮力不从心，束手无策。 边亮毫无法治意识，出狱后再次犯罪，在取保候审时期潜逃，被网上通缉。他在逃亡的两年中担惊受怕，尝到了人间的酸甜苦辣，渐渐懂得了生活的艰辛与不易。他时而良心发现，时而懵懂迷茫。 法院刘兰馨庭长对被告人边亮不是采取简单的一判了之，而是深入边亮的历史，了解他的过去，找出他屡次犯罪的原因。 在法官刘兰馨的努力下，浪子终于流下了悔恨的眼泪',
    author: '乔雅',
    cate1_id: '283',
    word_count: '173766',
    cover: 'https://readstatic.zhulang.com/res/cover/171/900/171900_180.jpg?1600362405'
  },
  {
    id: '161882',
    name: '蹦极',
    description: '主人公资深外交官钟良孤身一人，奉命来到大洋深处的热带小岛国吉多出任代办，要以一己之力，建起驻吉多大使馆。\r\n' +
      '吉多是一个小岛国，环境封闭，人烟稀少，民风粗犷。钟良在吉多开展工作，面对的是重重压力，险情和巨大的孤独，他的身上凝聚了外交官的责任感、荣誉感和高尚情操。\r\n' +
      '蹦极是吉多岛上一年一度的传统盛会，青年男子均踊跃参加。蹦极是一个隐喻，展现了外交工作的跌宕与艰险。',
    author: '卢山',
    cate1_id: '283',
    word_count: '201710',
    cover: 'https://readstatic.zhulang.com/res/cover/161/882/161882_180.jpg?1600365820'
  },
  {
    id: '151876',
    name: '人民利益',
    description: '本书以劳动关系为主线，描写了新时期工会干部的群像。以朔方省北梁市为背景，主人公呼维民三十多年前曾在北梁农村插队，后来又在当地东山机械厂当过工人。阴错阳差中，原本要安排担任副市长的呼维民，当上了这个城市的总工会主席。面对过去的乡亲、工友、同事，在经历了上访讨薪、金秋助学、寒门送暖，以及职工对立、同事误解、权谋等一系列事件，他对工会这个原本陌生的行来越来越熟悉，与职工群众越走越近，最终“搭错车走对路”，决心在这个“职工娘家人”的岗位上“一条道走到黑”……\n' +
      '该作品列入2019年山西省委宣传部重点扶持项目。',
    author: '关明',
    cate1_id: '283',
    word_count: '239916',
    cover: 'https://readstatic.zhulang.com/res/admincover/151/876/151876_180.jpg?1582785838'
  },
  {
    id: '161856',
    name: '防线',
    description: '上市生物制药公司星和集团，被所在地原人大主任实名举报，存在严重的安全隐患。市安委办副主任科员袁来临时受命，深入该企业所在街道，以普通安巡员的身份，调查该案件，却发现该企业的隐患，不仅事关生产安全，还因基因编辑、生物实验等对城市公共安全有着巨大的影响。与此同时，他也在不知不觉中，被卷入了一场与新型犯罪分子的殊死较量中。\r\n' +
      '小说选取特区经济社会快速发展的某一特定时刻，以“安巡员”这一群体切入，塑造特区安监人的典型形象，他们视国家、人民利益为最高利益，当好安全卫士，为国家平安稳定而拼搏奋斗，为城市构筑了一道安全防线。',
    author: '阿北',
    cate1_id: '283',
    word_count: '395974',
    cover: 'https://readstatic.zhulang.com/res/cover/161/856/161856_180.jpg?1600365840'
  },
  {
    id: '167615',
    name: '我的草原星光璀璨',
    description: '故事以青藏高原的腹地三江源地区为背景，讲述牧区脱贫遇到的苦难与问题，全景式展现了高原牧区脱贫攻坚的壮阔画卷。通过描写第一书记蓝堇时的蜕变，全景式地书写当下牧区人民的生活、理想和追求。\n' +
      '女主人公蓝堇时在江源村艰难而温暖地度过无数个日日夜夜，在生存环境艰苦的草原，用酥油灯照亮跋涉的荆棘，参与新时代的草原巨变，把民族文化、民族产业融入互联网的多种脱贫模式，寻求三江源生态保护与脱贫攻坚的平衡点，解决牧区妇女就业问题等人生历程，以女性视角表达对母亲河源头的生灵的敬畏与青藏高原上的生命礼赞！\n' +
      '入选2020年中国作家协会网络文学中心重点作品扶持。',
    author: '懿小茹',
    cate1_id: '285',
    word_count: '255879',
    cover: 'https://readstatic.zhulang.com/res/cover/167/615/167615_180.jpg?1600363810'
  },
  {
    id: '98287',
    name: '稔子花开',
    description: '穿百家衣吃百家饭的孤儿刘振华从名牌大学本科毕业后，拒绝省城大单位的橄榄枝，辜负心爱的女友，回到自己的家乡，鞠躬尽瘁回报家乡，立志要让落后山村脱贫，让村民的日子过得红红火火，但是……\n' +
      '该作品2018年获得广东省文化繁荣发展专项扶持项目、获得江苏省首届网络文学原创作品大赛二等奖。',
    author: '莫贤',
    cate1_id: '283',
    word_count: '271811',
    cover: 'https://readstatic.zhulang.com/res/cover/098/287/98287_180.jpg?1600370092'
  },
  {
    id: '165718',
    name: '共和国医者',
    description: '【同舟共济，战“疫”有我】【“新时代的中国”第二届全国网络文学现实题材主题征文大赛】王鹏骄2020抗疫题材“共和国系列”三部曲之一，长篇纪实文学。“中国医者，共和国健康的护城河；中国医者，五星红旗跃动的红色。”\n' +
      '入选2020年中国作家协会网络文学中心重点作品扶持。',
    author: '王鹏骄',
    cate1_id: '283',
    word_count: '43512',
    cover: 'https://readstatic.zhulang.com/res/cover/165/718/165718_180.jpg?1600364305'
  },
  {
    id: '157347',
    name: '海红飘香',
    description: '【连尚文学全网打造，全网点击过百万】\n' +
      '【首部中国东西扶贫网络文学作品】唯一正版阅读\n' +
      '故事以苏东省医疗队队到西部省小田家村医疗援助为开始，讲述在老党员以驻村第一书记李侯平的带领下，先消除村子因病致贫现象，然后以“产业脱贫、乡村振兴”为主线的故事，反映了在中国共产党的领导下东西部帮扶精神，体现了社会主义的优越性！\n' +
      '【全国唯一一部纪念苏陕扶贫协作20多年之作！】\n' +
      '【向中国共产党建党100周年献礼！】',
    author: '源上春树',
    cate1_id: '283',
    word_count: '211296',
    cover: 'https://readstatic.zhulang.com/res/cover/157/347/157347_180.jpg?1600367098'
  },
  {
    id: '175940',
    name: '锦绣鱼图',
    description: '抚远，自古被称为华夏东极，传说太阳自此升起。\r\n' +
      '美丽的乌苏里江，鱼皮画传承千年。\r\n' +
      '“自从搭上了电商快车，鱼皮画这个冷门生意也终于热了起来，今天谈成了一笔400件鱼皮工艺品的订单呢。”\r\n' +
      '赫哲族小伙刘三顺如是说。',
    author: '吴半仙',
    cate1_id: '283',
    word_count: '393370',
    cover: 'https://readstatic.zhulang.com/res/cover/175/940/175940_180.jpg'
  },
  {
    id: '158828',
    name: '不负韶光',
    description: '十八大后，归国侨眷夏棘青因旧城区改造，和新小孜、谭鸣声、季陶然等年轻人因缘聚会在城郊综合社区东江新城。滞后的配套与服务让他心有抵触，成为在网络中挑剔问题的“毛毛虫”，微博与微信公众号“新城夜话”成为居民吐槽的负面平台。伴随城市文明建设与基层治理创新的深入，夏棘青不知不觉开始参与社区公益服务，与街坊邻里上演了许多啼笑皆非的故事，随后在基层党组织帮助和支持下，自觉创立”网络多媒体自治联盟”，与年轻伙伴们共同实现“八步蝶变”，描绘出爱情、亲情、友情的美丽画卷，展现改革创新进程中，党组织克难求进，关心引导新青年转变思维，积极投身社会治理，发展成为团青年先锋、文明好网民的真实轨迹。\n' +
      '江苏省2020年主题出版重点出版物选题、中国作家协会网络文学中心重点作品扶持。',
    author: '月壮边疆',
    cate1_id: '283',
    word_count: '899783',
    cover: 'https://readstatic.zhulang.com/res/cover/158/828/158828_180.jpg?1600366743'
  },
  {
    id: '166287',
    name: '人间重晚晴',
    description: '尊敬老人，是中国文化的传统。可是，随着现代化进程不断加快，老年人生活不便问题越来越突出，传统的养老服务方式已呈现出严重的不适应。在未富先老的环境条件下，如何解决乡村养老服务问题，显得任重道远。 “天意怜幽草，人间重晚晴。”她克服重重困难，扭转了“只能居家养老”的传统观念，改善老人的生活条件和精神面貌，让老人获得幸福感。最终和同伴们一起携手，让老年人开出生活幸福之花。',
    author: '狐小妹',
    cate1_id: '285',
    word_count: '216286',
    cover: 'https://readstatic.zhulang.com/res/cover/166/287/166287_180.jpg?1600364015'
  },
  {
    id: '164014',
    name: '亲爱的，二进制',
    description: '5G时代，海归女胥姝英国归来，投身AI研发，与麻省理工学院人工智能王子叶通并肩面对人工智能、大数据、云计算黑科技年代风起云涌。技术封锁、商海暗斗、贸易争端、感情纠葛，大戏接踵而至。姝姝和叶通笑看风云，突破技术壁垒，让安防机器人、语音机器人、售货机器人惊艳呈现，让“中国设计”在国际舞台完美彰显。作品为2020年上海文化艺术资助项目。',
    author: '唐墨',
    cate1_id: '61',
    word_count: '211392',
    cover: 'https://readstatic.zhulang.com/res/cover/164/014/164014_180.jpg?1600364869'
  },
  {
    id: '175941',
    name: '冰魂',
    description: '辗瑞雪为土，凝洁冰为魂。\n' +
      '以冰为主要材料来雕刻的艺术形式，在我国已经有了数百年的历史。\n' +
      '这是一部见证着冰雕行业兴衰的小说，\n' +
      '描绘新老冰雕艺术家们的苦乐酸甜。\n' +
      '本书以冰雪艺术家孟献国、王海峰两位老师真实经历改编。\n' +
      '特别鸣谢：\n' +
      '哈尔滨市职工摄影家协会',
    author: '素衣凝香',
    cate1_id: '283',
    word_count: '246789',
    cover: 'https://readstatic.zhulang.com/res/cover/175/941/175941_180.jpg'
  },
  {
    id: '160678',
    name: '印染年华',
    description: '讲述从1984年到2018年，村中青年党员们响应国家奔小康的号召，在绍兴市工商局的指引下，在绍兴市政府的帮助下，全村联合开办集体企业，赶上时代洪流，带领全村致富奔小康的故事。',
    author: '大江东',
    cate1_id: '283',
    word_count: '513348',
    cover: 'https://readstatic.zhulang.com/res/cover/160/678/160678_180.jpg?1600366172'
  },
  {
    id: '176124',
    name: '国企重生',
    description: '国营颜山电机厂破产了。\r\n' +
      '这厂是鲁博和战友们在胶东抗日时用生命创建的，他不能眼睁睁看着为共和国做出贡献的企业倒下。\r\n' +
      '已经退休多年的鲁博不听老伴的劝阻拄着拐来到了厂部，冲到了现党委书记兼董事长宁川主持召开最后一次会议上，把厂部一班人骂了个狗血喷头不说，竟然跑到市委硬是把资不抵债的电机厂承包了下来。\r\n' +
      '鲁博的壮举使得宁川愧疚难当，本来过几天就到区里上班的他，也下了个决心：与厂子共生存！\r\n' +
      '可是资不抵债，哪家银行也不敢贷给他们，甭说贷了，前来讨债的挤破了门。\r\n' +
      '鲁博把全部积蓄拿了出来，宁川也凑了八十万，全厂上上下下在鲁博无声的带头下无偿地集资救企业。\r\n' +
      '可热血并不等于现实。\r\n' +
      '没有市场！残酷的现实摆在面前！\r\n' +
      '鲁博带领厂销售处的营销人员踏上了北去的列车。\r\n' +
      '北方汽车制造厂是特大企业，汽车厂的朱顺丰总经理感动了，抛开他爸是鲁博当年战争年代的警卫员不说，就凭这近百岁的老人能够不远千里为了厂里的生死存亡，也足够看出一个老党员的赤诚之心。\r\n' +
      '销路解决了，但又一拦路虎出现了——质量！\r\n' +
      '颜山电机厂第一次让配套厂家退回了百分之八十的产品。理由：质量不合格！\r\n' +
      '鲁博同宁川等厂领导班子下沉到了分厂、车间、班组，和工人师傅同工同劳动。\r\n' +
      '质量是生命！厂是大家的，也是每个人的饭碗。\r\n' +
      '企业刚刚有了生机，鲁博突然倒在了厂部召开的居安思危座谈会上。\r\n' +
      '鲁博在弥留之际，把刚从美国赶回来的儿子鲁浩的手交到了一刻都没有离开他身旁的宁川的手里。\r\n' +
      '他让鲁浩辞去在美国知名电气公司技术总监的职务，回来服务于生他养他的颜山电机厂。\r\n' +
      '看到这个为党献出一辈子的老父亲还要把儿孙献上，鲁浩自然心里翻江倒海，但他内心的理想主义精神力量使他绝然地留了下来。\r\n' +
      '鲁浩接过了颜山电机厂的重任，没多久，就面临着市场的技术升级、产品淘汰一系列大环境的转折。\r\n' +
      '国外的著名企业悄然进入了国内，市场竞争残酷地摆在了面前。颜山电机又面临着一次',
    author: '老宏',
    cate1_id: '283',
    word_count: '806589',
    cover: 'https://readstatic.zhulang.com/res/cover/176/124/176124_180.jpg'
  },
  {
    id: '166276',
    name: '月满长街',
    description: '如果城市有生命，那么老街就是它的记忆。\n' +
      '当你疲倦晚归时，这里：\n' +
      '有母亲热腾腾的一碗汤面。\n' +
      '有妻子彻夜守候的一盏灯火。\n' +
      '有盼望游子归来的一双双目光。\n' +
      '老街即将拆去，新城拔地而起，在千家万户的变迁中，总有那么一些故事，一些感动，在悄悄上演。\n' +
      '如果累了，倦了，就回家歇一歇。\n' +
      '这里阖家温暖，月满长街。\n' +
      '入选2020年中国作家协会网络文学中心重点作品扶持。',
    author: '吴半仙',
    cate1_id: '283',
    word_count: '667161',
    cover: 'https://readstatic.zhulang.com/res/cover/166/276/166276_180.jpg?1600364022'
  },
  {
    id: '170802',
    name: '刺猬的微光',
    description: '邵凌霜毕业没几年就面临着一个重要的难题：母亲过世之后，同母异父的脑瘫弟弟的归宿在她的生活当中引起了轩然大波。\r\n' +
      '爱心组织的牵头人姜源是一个“怀柔”的人，他极力探寻着自己的价值，工资积蓄都用在了特殊儿童救助之上，因此一直未婚。\r\n' +
      '邵凌霜与姜源在“相亲局”上狭路相逢，她对弟弟所引发的后续问题焦头烂额，但姜源的介入恰到好处的给了邵凌霜一抹微光。\r\n' +
      '至此，邵凌霜开始寻找自己的价值，她决定与姜源站在一起，一同见证了多个深陷泥潭的家庭里的酸甜苦辣，她也真正爱上了那一群被时光所遗忘的孩子。',
    author: '大橙子',
    cate1_id: '283',
    word_count: '302025',
    cover: 'https://readstatic.zhulang.com/res/cover/170/802/170802_180.jpg?1600362792'
  },
  {
    id: '163997',
    name: '荣耀之上',
    description: '消防局紧急救援特别行动组组长向薇是退役军人，做事雷厉风行，做人风格强悍，自从最崇敬的队长兼爱人在一场大火之中牺牲之后，她藏起悲痛，成为这只无名英雄小队的队长。在这座城市内，每天都有大大小小的状况发生，城市救援队有应必回，使命必达。英雄永不会被遗忘，因为英雄的背后，还有人愿意继续负重前行，成为新的荣光。\r\n' +
      '【入选2020年度河南省精神文明建设“五个一工程”重点创作项目。】',
    author: '麦苏',
    cate1_id: '61',
    word_count: '532635',
    cover: 'https://readstatic.zhulang.com/res/cover/163/997/163997_180.jpg?1600364881'
  },
  {
    id: '171050',
    name: '绿水金山',
    description: '新媒体主播叶晨与大学生村官于涵强强联手，利用新媒体电商平台的优势，带货农副产品，推动乡村旅游，建设家乡。不但收获了爱情，还帮助家乡脱贫致富。这是一个当代年轻人利用新兴平台，崭新的励志创业脱贫致富全民奔小康的故事。',
    author: '就为活着',
    cate1_id: '283',
    word_count: '735021',
    cover: 'https://readstatic.zhulang.com/res/cover/171/050/171050_180.jpg?1600362649'
  },
  {
    id: '167739',
    name: '正义辩权',
    description: '本书取得2020年“广西玉林市文艺人才文艺精品项目扶持作品”荣誉。 在法律面前，无论你是贫穷或是富贵，人人都是平等的，正义永远站在法律的那一边。帅气律师与美女记者上演一场轰轰烈烈的正义追逐。',
    author: '我本纯洁',
    cate1_id: '283',
    word_count: '548957',
    cover: 'https://readstatic.zhulang.com/res/cover/167/739/167739_180.jpg?1600363754'
  },
  {
    id: '157415',
    name: '最后的村庄',
    description: '新世纪初，在城市化进程中，豫西九龙山区明清古村落——瓦罐村，人去村空，最后一户人家中九十七岁的老红军魏长庚和他的侄子魏石寨以及他们的忠实朋友老黄狗，一同守护着这里的好山好水和老祖先留下的古村落。在他们的努力下，不但守住了绿水青山，而且使这一古村落得到了开发利用，成为旅游胜地。然而，魏长庚老人却永远长眠于此……\n' +
      '本书获得2019扬子江原创网络文学大赛二等奖。【向新中国成立70周年献礼参赛作品】',
    author: '塬上草',
    cate1_id: '283',
    word_count: '329292',
    cover: 'https://readstatic.zhulang.com/res/cover/157/415/157415_180.jpg?1600367057'
  },
  {
    id: '156207',
    name: '俗艺大师',
    description: '东北有句老话，宁舍一顿饭，不舍二人转。\n' +
      '二人转是流传在东北黑土地上最具特色的地方戏之一，说唱伴舞绝，一身都是活。\n' +
      '这一门老艺术形式如今已经被列入国家非物质文化遗产名录。\n' +
      '经历三百年的起起伏伏，二人转曾经的辉煌已经逝去，逐渐暗淡无光。\n' +
      '在各种戏曲纷纷走上国际舞台的时候，终于，有一个人，开始书写二人转的传奇。\n' +
      '【2019扬子江原创网络文学大赛二等奖】\n' +
      '【2019全国首届现实题材主题征文大赛完结组三等奖】',
    author: '就为活着',
    cate1_id: '283',
    word_count: '377445',
    cover: 'https://readstatic.zhulang.com/res/admincover/156/207/156207_180.jpg?1582780325'
  },
  {
    id: '167614',
    name: '一条搜救犬的见证',
    description: '我叫大美，是一条有编号的搜救犬，我参加过许多的搜救工作，我从快要塌方的矿井下面把人拽出来，我在荒野里找到走丢了的老爷爷，我从桥洞下找到离家出走的孩子，我在孤岛上寻找到了摔晕的驴友，我还参加了一个民间救援队，由许多退伍老兵组建，我陪着他们一起成长，见证他们的勇敢、果断和大爱无畏，这是一支最优秀的救援队，我的训导员也是最优秀的，而我——大美，最优秀的搜救犬，不许反驳！',
    author: '煜素',
    cate1_id: '283',
    word_count: '666523',
    cover: 'https://readstatic.zhulang.com/res/cover/167/614/167614_180.jpg?1600363811'
  },
  {
    id: '152327',
    name: '昨夜海棠依旧',
    description: '奶奶去世后，杨梳妆归国念书，毅然放弃国外多年积累的美声学习，而是选择了已呈落败的昆剧。适才二八，方是豆蔻年华，捻手顿足，举是穷仙之姿。年轻便是资本，即便这条路艰难崎岖，杨梳妆仍是用毅力和梦想，在这条不归路上，唱出一片新天地。\n' +
      '【向新中国成立70周年献礼参赛作品】\n' +
      '【世界非物质文化遗产：昆剧】\n' +
      '【2019江苏省优秀版权作品文学类三等奖】',
    author: '月一半',
    cate1_id: '283',
    word_count: '301793',
    cover: 'https://readstatic.zhulang.com/res/cover/152/327/152327_180.jpg?1600367704'
  },
  {
    id: '130296',
    name: '第二次初婚',
    description: '她是最底层的试睡师，一个被误解的新兴行业，可她缔造了管理学上最强悍的传奇。二十年如一日的坚持，她终于以中国人的身份在国际舞台上站稳脚跟。平凡的岗位，绽放着最可爱的守护，缔结出纯洁美好的守望。 2019年中国作家协会网络文学中心重点扶持作品。',
    author: '凌晨',
    cate1_id: '61',
    word_count: '286472',
    cover: 'https://readstatic.zhulang.com/res/admincover/130/296/130296_180.jpg?1582775845'
  },
  {
    id: '151823',
    name: '维和先锋',
    description: '我叫肖强兵，一个远征北美战乱区的维和警察，戴上“地球与橄榄枝”肩章的刹那，维护和平、打击犯罪、传播华夏文化就成了我最大的追求……面对狂徒、灾难、战争王、阴谋家和各种圈套陷阱，我不是打不死的小强，只要我到达的地方，那里就会迎来光明和希望！\n' +
      '向新中国成立70周年献礼现实题材征文大赛参赛作品。',
    author: '蓝盔战歌',
    cate1_id: '283',
    word_count: '1661806',
    cover: 'https://readstatic.zhulang.com/res/admincover/151/823/151823_180.jpg?1582776181'
  },
  {
    id: '159657',
    name: '冰上的华尔兹',
    description: '经过一次打击后，夏天晴以为自己都不会碰冰刀了，大学时顾清平的出现打断了她颓废的两年。\r\n如同一缕清晨的阳光，拨开云雾，照射在她眼前。',
    author: '艾镜',
    cate1_id: '75',
    word_count: '200370',
    cover: 'https://readstatic.zhulang.com/res/cover/159/657/159657_180.jpg?1600366509'
  },
  {
    id: '156208',
    name: '百年复兴',
    description: ' 讲述因着高考改变人生的两种铁路人生，以主人公人生的变化，明志初心，以坚持不懈的钻研精神和团结凝聚力，改善人生，改变未来的故事。 故事是1989年-2012年改革开放时期，通过老中青三代人的奋斗，以科教兴国为故事基调，以《全国教育事业第十个五年计划》、《中华人民共和国职业教育法》等为蓝图，通过教育工作者、铁路领导人、进步青年在改革开放中奋斗不息的情景再现，描绘一幅中国老一辈铁路和教育工作者、乡镇年轻人为国家崛起与富强而奋斗的画卷，以少见的铁路与教育为双主线的故事架构，将中国计划以三代人，用近七十年的时间，在2050年实现百年复兴的梦想具象化。 向新中国成立70周年献礼现实题材征文大赛参赛作品。',
    author: '大江东',
    cate1_id: '283',
    word_count: '5720993',
    cover: 'https://readstatic.zhulang.com/res/admincover/156/208/156208_180.jpg?1582785938'
  },
  {
    id: '151918',
    name: '红旗飘扬',
    description: '看着满目疮痍，尸横遍野的战场，那里躺着自己的兄弟、亲人、爱人……李立龙把砍卷了的大刀往地上一插，沧然泪下！\n' +
      '他不明白战争，但他知道一点：当无可避之时，就要勇敢面对！付出一切，在所不惜！火树出品，值得品鉴！\n' +
      '向新中国成立70周年献礼现实题材征文大赛参赛作品。',
    author: '火树',
    cate1_id: '26',
    word_count: '1911807',
    cover: 'https://readstatic.zhulang.com/res/admincover/151/918/151918_180.jpg?1582785869'
  },
  {
    id: '152196',
    name: '刺猬小姐向前冲',
    description: '北漂，是林佳人生之中最勇敢的一次选择。\n' +
      '她从不惧怕未知的恐慌，只担心失去掌控人生的权利。\n' +
      '8岁到18岁，她苦练刺绣十年。\n' +
      '19岁到28岁，她成为投资集团独当一面的资深经理人。\n' +
      '人生却永远是一个圈，兜兜转转，回到最初。\n' +
      '29岁这一年，她重新捏起了针线，在底布上绣出了深邃宇宙，在职场绣出了华丽人生。\n' +
      '她终于明白，那个在某天踩着七彩祥云来救赎她的英雄， 一直是她自己。\n' +
      '这是一个外柔内刚的小女子从职场白领，蜕变成创业女王的故事。\n' +
      '很久以后，林佳才恍然，人生之中的每一次重要选择，都是在某个不起眼的午后，随意做出。\n' +
      '【向新中国成立70周年献礼参赛作品】作品荣获2019年度中原文艺精品创作工程重点项目扶持；2019全国首届现实题材主题征文大赛完结组二等奖。',
    author: '麦苏',
    cate1_id: '61',
    word_count: '428981',
    cover: 'https://readstatic.zhulang.com/res/admincover/152/196/152196_180.jpg?1582776269'
  },
  {
    id: '163181',
    name: '归时舒云化春雪',
    description: '人生就像是一条奔波向海，永不回头的河流，当你从源头走来，一路向海的时候，也许种种的支流会让人迷失方向。幸福与快乐也许看似遥遥无期，可在下一个转弯时，便会突然出现在你的面前。当江舒云走进武校的时候，她便开始了人生的选择，这选择或许只是出于无奈或者幻想，作为一个女人，她在生活的压力下，只能选择这种危险地方式来追求未来。但是压力和无奈并不意味着未来也是如此，当她住进602室的时候，命运似乎将她引入了另外一条支流，而这条支流将会为她带来什么样的改变，便是江舒云自己，都说不清，道不明，只有暗暗地欢喜藏在心中。作品荣获2019年河南省直文艺创作人员“深入生活、扎根人民”创作扶持，同时入选2019年度河南省作家协会重点扶持。',
    author: '麦苏（甘海晶）',
    cate1_id: '61',
    word_count: '532630',
    cover: 'https://readstatic.zhulang.com/res/admincover/163/181/163181_180.jpg?1582780502'
  },
  {
    id: '152241',
    name: '荣光不会晚',
    description: '生活一向如此，你永远不知道明天和意外哪个会先来。 金雪，有丈夫，有孩子，知足而快乐，从没想过自己会转眼之间离婚，成为单亲妈妈。 安逸的生活被彻底打破，她几经辗转，找到了自己的方向。 南京泥人，是她童年的快乐和理想，更是祖父辈的老手艺，传统匠人行业凋敝，机缘巧合，金雪走上了改良、发扬和推广南京泥人的创业之路。 这条路荆棘密布，险象环生，可是她从来没有害怕过，反而越挫越勇。 第二次人生，充满迷茫和未知，可她从不畏惧挑战困难，挑战自己。 【向新中国成立70周年献礼参赛作品】获2019扬子江网络文学原创作品大赛优胜奖；2019全国首届现实题材主题征文大赛完结。',
    author: '朵朵麻',
    cate1_id: '138',
    word_count: '226528',
    cover: 'https://readstatic.zhulang.com/res/cover/152/241/152241_180.jpg?1600367711'
  },
  {
    id: '158967',
    name: '核医荣誉',
    description: '“战乱救国，和平救人。核医荣誉，属于祖国，属于人民。”国内核医题材开创者、三甲医院核医学工作者王鹏骄继“2019中作协重点扶持项目《核医荣光》”后，以核医工作纪实为篮本改编的全新医疗现实题材小说，本故事为作者核医“荣”系列III部曲第II部。以无名革命烈士精神为指引，讲述了汉东医院核医学科研型技术医生李荣誉与团队利用核医诊疗理念为人们解决无数疑难杂症，并一步步实现自我成长自我救赎的故事，同时将因疾结缘的不同行业病患身后故事与冷暖自知的人间百态推陈出新地交给观者。\n' +
      '【2019全国首届现实题材主题征文大赛未完结组优秀奖】',
    author: '王鹏骄',
    cate1_id: '283',
    word_count: '138298',
    cover: 'https://readstatic.zhulang.com/res/admincover/158/967/158967_180.jpg?1582780470'
  },
  {
    id: '152359',
    name: '盛开的米兰花',
    description: '刚毕业的师范生米兰，满怀信心的想成为一名优秀的教育工作者，可现实遇到了种种困难，她这朵刚刚绽放的米兰花，能否抵抗得住风吹雨打？是否能实现教育公平，推动教育改革，以及完善教育理念的理想？\n' +
      '【向新中国成立70周年献礼参赛作品】作品荣获2019扬子江原创网络文学大赛优胜奖；2019全国首届现实题材主题征文大赛完结组三等奖。',
    author: '炫炫',
    cate1_id: '61',
    word_count: '202910',
    cover: 'https://readstatic.zhulang.com/res/admincover/152/359/152359_180.jpg?1582952307'
  },
  {
    id: '156205',
    name: '心铸天途',
    description: '西泽村是个贫困落后的小山村，二十年前倾尽全村人之力打通一条通往外界的天路。二十年后，一场特大山洪爆发毁了这条天路，葬送了村子发展的希望。　　一群封建迷信思想的守旧派人员，大肆鼓吹山神论，侵蚀村民的思想。　　面对自然天灾，守旧派村民和进步思想村民形成两大极端矛盾，小山村再次陷入重大发展危机。　　身为村支书的顾泽山，带领村干部们不畏艰难险阻，对封建迷信思想宣战，勇敢战胜天灾，发动村民重新打通被封死的天路。　　带领全体村民为小山村的发展谋思路，走上脱贫致富之路，谱写一曲基层党员干部无私奉献，拼搏奋斗的赞歌。\n' +
      '向新中国成立70周年献礼现实题材征文大赛参赛作品。',
    author: '大眼猫神',
    cate1_id: '283',
    word_count: '341954',
    cover: 'https://readstatic.zhulang.com/res/admincover/156/205/156205_180.jpg?1582780209'
  },
  {
    id: '159044',
    name: '浮生戏',
    description: '他是时尚都市里执掌上亿项目的会计师，却在父亲离世后接手了受众日渐萎缩的潮剧剧社；她是自小便在潮剧戏校里成长起来的旦角，虽知剧社举步维艰却不愿离开……\r\n' +
      '承受流行文化冲击的“非遗文化”逐渐被淡忘，现代营销手段和艺术设计的涉入却让尘封的魅力重焕生机。\r\n' +
      '一人一戏一剧社，且看韩儒伶带着父亲留下的浮生戏剧社如何绝处逢生……\r\n' +
      '【向新中国成立70周年献礼参赛作品】作品荣获2019全国首届现实题材主题征文大赛未完结组三等奖。',
    author: '玉珊瑚',
    cate1_id: '61',
    word_count: '211483',
    cover: 'https://readstatic.zhulang.com/res/cover/159/044/159044_180.jpg?1600366672'
  },
  {
    id: '156201',
    name: '人间团圆',
    description: '作品以“打拐”为主题，生动描写了一个有着严重小民思想的普通青年，在“打拐”的道路上，思想不断升华，最后倾其所有，只为帮助那些失去孩子的可怜家庭，找回被拐的孩子，让他们合家团圆。作品充分展现了随着时代发展，人们的思想品格不断升华，实现了从“小我”到“大我”的思想转变。 向新中国成立70周年献礼现实题材征文大赛参赛作品。',
    author: '水漾胭脂',
    cate1_id: '283',
    word_count: '290531',
    cover: 'https://readstatic.zhulang.com/res/admincover/156/201/156201_180.jpg?1582780065'
  },
  {
    id: '153083',
    name: '医触即发',
    description: '一场意外，简欣的父亲在车祸中死去，铸成了她心底的执念。\n' +
      '十五年后，长大后的简欣如愿进入仁济医院急诊科。\n' +
      '这里是急诊科，也是与死神争分夺秒的战场！\n' +
      '守护生命，成为唯一职责。\n' +
      '向新中国成立70周年献礼参赛作品。',
    author: '紫菲子',
    cate1_id: '285',
    word_count: '227977',
    cover: 'https://readstatic.zhulang.com/res/admincover/153/083/153083_180.jpg?1582780004'
  },
  {
    id: '156206',
    name: '酒匠',
    description: '社会发展迅速，老一辈的手工酿酒技艺逐渐被机械代替，茂云云家族的传统茅台酿造法到这一代只有她一个人继承。 小酒种推陈出新，新酿酒技术高产，曾经红极一时的几大名酒销声匿迹，市场上，假的假乱的乱。 拍卖会上，茂云云因为拒拍父亲亲手酿造的茅台酒认识陈栋，违约而和他签订劳务合同。 陈栋自己开发新型小酒种，工厂更是大规模生产“没有灵魂”的酒水，茂云云对其十分不屑。 两种工艺碰撞，新文化与旧工艺擦出火花。 在接触的过程中，茂云云渐渐懂得理解和包容新酒的存在价值，陈栋也渐渐懂得欣赏和接纳老工艺的魅力。 两人相惜又互相看不顺眼，相对又互相帮助，各自为了理想为了事业不断成长着。 向新中国成立70周年献礼现实题材征文大赛参赛作品。',
    author: '甘源316',
    cate1_id: '61',
    word_count: '305033',
    cover: 'https://readstatic.zhulang.com/res/admincover/156/206/156206_180.jpg?1582780271'
  },
  {
    id: '36703',
    name: '黑白禁区',
    description: '本书重在弘扬我国我党的爱国主义建设，突出表现我军我公安干警的风采，揭开军人们鲜为人知的一面，和他们饱受着心理上的巨大压力。而当一个缉毒警察的痛点被一次次的击中，他的亲人，兄弟一次次的被灼伤，被摧残，他疯了，他一头撞进那个无法分辨黑白的禁区里，嘶吼着拼命前行，永无止境。\n' +
      '2018年中国作家协会重点扶持作品。由欧豪主演的本书同名当代缉毒刑侦网剧即将播出。',
    author: '东岳不苦',
    cate1_id: '283',
    word_count: '772204',
    cover: 'https://readstatic.zhulang.com/res/admincover/036/703/36703_180.jpg?1582774605'
  },
  {
    id: '141157',
    name: '属于你的那一缕阳光',
    description: '李发财，一个普通的监狱警察，一个不聪明的实诚人。他没有想过自己有一天会成为英雄，只是认为自己做了自己该做的事情，实际上，在犯人的眼里、心里他成了严父、慈母，是一缕希望的阳光，十几年的玉汝于成，他成为了一个活着的烈士！ 向新中国成立70周年献礼现实题材征文大赛参赛作品。',
    author: '韩太明',
    cate1_id: '283',
    word_count: '538094',
    cover: 'https://readstatic.zhulang.com/res/admincover/141/157/141157_180.jpg?1582776005'
  },
  {
    id: '156204',
    name: '牛建国一家',
    description: '描写生活在川西坝子益县的牛建国一家四代人的人生际遇，讲述新中国成立70周年以来城乡发展变化的故事。\n' +
      '卷一：落霞与孤鹜齐飞，通过牛牾驷的人生故事，展现解放前后在江苏新阳县亲人们的故事，及他在益县安家，并在灌县等周边县市工作、生活的故事。\n' +
      '卷二：惊涛卷起千堆雪，通过牛建国的成长讲述新中国发展到今天的故事，从农村到城市，他与亲友一起为国家的建设贡献一份力量的故事。\n' +
      '卷三：神女当惊世界殊，通过牛开放的成长讲述改革开放后的四十年间，城乡发展变化，以及牛家人是如何在新形势下工作、生活及学习的故事。\n' +
      '向新中国成立70周年献礼现实题材征文大赛参赛作品。',
    author: '蜀汉搏风',
    cate1_id: '283',
    word_count: '778710',
    cover: 'https://readstatic.zhulang.com/res/admincover/156/204/156204_180.jpg?1582780178'
  }
]


const cate_map = {
  "1": "修真武侠",
  "2": "传统武侠",
  "3": "古典仙侠",
  "4": "现代仙侠",
  "5": "武侠幻想",
  "6": "玄幻小说",
  "7": "东方玄幻",
  "8": "西方魔幻",
  "9": "异界争霸",
  "10": "现代魔法",
  "11": "洪荒史诗",
  "12": "现代修真",
  "13": "异能奇书",
  "14": "黑暗幻想",
  "15": "动漫游戏",
  "16": "武侠同人",
  "17": "影视同人",
  "18": "动漫同人",
  "19": "游戏同人",
  "21": "小说同人",
  "22": "历史小说",
  "23": "历史传记",
  "24": "穿越历史",
  "25": "架空历史",
  "26": "军事小说",
  "27": "战争幻想",
  "28": "军旅生涯",
  "29": "谍战特工",
  "30": "都市小说",
  "31": "都市生活",
  "32": "热血成长",
  "33": "都市异能",
  "34": "娱乐明星",
  "35": "青春校园",
  "36": "职场商战",
  "37": "科幻小说",
  "38": "未来世界",
  "39": "宇宙争霸",
  "40": "古武机甲",
  "41": "未世进化",
  "42": "时空穿梭",
  "43": "超级科技",
  "44": "网游小说",
  "45": "游戏生涯",
  "46": "电子竞技",
  "47": "虚拟网游",
  "48": "游戏异界",
  "50": "推理",
  "51": "推理悬念",
  "52": "恐怖惊悚",
  "53": "灵异鬼怪",
  "54": "风水秘术",
  "55": "探险异闻",
  "56": "竞技体育",
  "57": "体育竞技",
  "58": "篮球运动",
  "59": "足球运动",
  "60": "棋牌桌游",
  "61": "现代言情",
  "62": "都市情缘",
  "63": "总裁豪门",
  "64": "婚恋家庭",
  "65": "职场白领",
  "66": "异术超能",
  "67": "娱乐巨星",
  "68": "古代言情",
  "69": "古代情缘",
  "70": "穿越架空",
  "71": "女尊权谋",
  "72": "宫闱宅斗",
  "73": "经商种田",
  "74": "古代历史",
  "75": "浪漫青春",
  "76": "青春校园",
  "77": "禁忌绝恋",
  "78": "百合之恋",
  "79": "原创耽美",
  "80": "同人耽美",
  "81": "玄幻异能",
  "82": "玄幻异世",
  "83": "奇幻魔法",
  "84": "悬疑",
  "85": "推理探案",
  "86": "惊悚恐怖",
  "87": "灵异志怪",
  "88": "神秘文化",
  "89": "古墓迷踪",
  "90": "武侠仙侠",
  "91": "仙侠奇缘",
  "92": "古典仙侠",
  "93": "洪荒封神",
  "94": "动漫游戏",
  "95": "女生同人",
  "96": "换身入替",
  "97": "萌系小说",
  "99": "古装",
  "100": "武侠",
  "101": "言情",
  "102": "伦理",
  "103": "都市",
  "104": "职场",
  "106": "古典名著",
  "107": "现代名著",
  "108": "社科科普",
  "109": "经管励志",
  "111": "国外青春文学",
  "112": "港台青春文学",
  "113": "韩国青春文学",
  "114": "爱情情感",
  "115": "校园",
  "116": "叛逆成长",
  "118": "外文小说",
  "119": "情感小说",
  "120": "官场职场",
  "121": "文史传记",
  "122": "宗教哲学",
  "123": "生活随笔",
  "125": "各国历史",
  "126": "通俗说史",
  "127": "文物考古",
  "128": "地方史志",
  "129": "史家专著",
  "130": "历史随笔",
  "132": "历史人物",
  "133": "人物集合",
  "134": "艺术家",
  "135": "法律人物",
  "136": "宗教人物",
  "137": "女性人物",
  "139": "婚姻",
  "140": "性知识",
  "141": "婚恋综合",
  "142": "恋爱",
  "143": "育儿",
  "145": "政治理论",
  "146": "中国政治",
  "147": "世界政治",
  "148": "外交国际关系",
  "149": "各国政治",
  "150": "公共管理",
  "151": "政党读物",
  "156": "军事史",
  "159": "其他",
  "160": "其他",
  "161": "其他",
  "162": "其他",
  "163": "职场商战",
  "165": "青年文学",
  "166": "青年文摘",
  "167": "短篇",
  "168": "都市小说",
  "169": "玄幻科幻",
  "170": "灵异悬疑",
  "171": "武侠仙侠",
  "172": "历史军事",
  "173": "同人小说",
  "174": "其他",
  "175": "短篇",
  "176": "总裁豪门",
  "177": "婚恋职场",
  "178": "穿越架空",
  "179": "宫斗宅斗",
  "180": "悬疑灵异",
  "181": "浪漫青春",
  "182": "其他",
  "183": "都市情感",
  "184": "婚姻与家庭",
  "185": "2018年",
  "186": "2015年",
  "187": "2016年",
  "188": "2017年",
  "189": "2018年",
  "190": "体育健康",
  "191": "足球周刊",
  "192": "玄幻",
  "193": "都市",
  "194": "恐怖",
  "195": "校园",
  "196": "悬疑",
  "197": "科幻",
  "198": "生活",
  "199": "热血",
  "200": "爆笑",
  "201": "纯爱",
  "202": "历史",
  "203": "少儿",
  "204": "动作",
  "205": "战争",
  "206": "彩虹",
  "207": "萌系",
  "208": "穿越",
  "209": "后宫",
  "210": "唯美",
  "211": "玄幻",
  "212": "都市",
  "213": "恐怖",
  "214": "校园",
  "215": "悬疑",
  "216": "科幻",
  "217": "生活",
  "218": "热血",
  "219": "爆笑",
  "220": "纯爱",
  "221": "历史",
  "222": "少儿",
  "223": "动作",
  "224": "战争",
  "225": "彩虹",
  "226": "萌系",
  "227": "穿越",
  "228": "后宫",
  "229": "唯美",
  "230": "古风",
  "231": "古风",
  "232": "魔幻",
  "233": "魔幻",
  "234": "治愈",
  "235": "治愈",
  "236": "武侠",
  "237": "武侠",
  "238": "知音",
  "239": "故事传奇",
  "240": "山海经",
  "241": "2018",
  "242": "2017",
  "246": "2016",
  "247": "2018",
  "248": "2017",
  "249": "今古传奇故事版",
  "250": "2018",
  "251": "2017",
  "252": "2016",
  "253": "今古传奇单月号",
  "254": "2017",
  "255": "2018",
  "256": "2018",
  "257": "2017",
  "258": "2016",
  "259": "2018",
  "260": "2017",
  "261": "2016",
  "262": "2015",
  "263": "经典武侠",
  "264": "金庸全集",
  "265": "梁羽生全集",
  "266": "古龙精选",
  "267": "经典言情",
  "268": "琼瑶精选",
  "269": "青春文学",
  "270": "经典名著",
  "271": "古典名著",
  "272": "外国名著",
  "273": "近代名家",
  "274": "健康心灵",
  "275": "保健养生",
  "276": "宗教哲学",
  "277": "生活随笔",
  "278": "当代文学",
  "279": "长篇小说",
  "280": "科幻",
  "281": "历史小说",
  "282": "都市职人",
  "283": "现实",
  "284": "现实",
  "285": "现实",
  "286": "现实",
  "287": "经典读本",
  "288": "经管励志",
  "289": "军事谍战",
  "290": "人文社科",
  "291": "诗歌散文",
  "292": "商战权谋",
  "293": "影视传奇",
  "294": "纪实文学",
  "295": "名人传记"
}

export { book_list, cate_map }


// WEBPACK FOOTER //
// ./src/module/active_jd/books.js